module.exports = __webpack_public_path__ + "static/media/8.c1f876a3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/8.mp3
// module id = 87
// module chunks = 0